import React from "react";

export const MaintenanceDepartmentIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.75 8.24805V12.4147" stroke="white" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.75 18.5895H5.70002C2.80835 18.5895 1.60002 16.5228 3.00002 13.9978L5.60002 9.31445L8.05002 4.91445C9.53335 2.23945 11.9667 2.23945 13.45 4.91445L15.9 9.32279L18.5 14.0061C19.9 16.5311 18.6833 18.5978 15.8 18.5978H10.75V18.5895Z" stroke="white" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.7454 14.915H10.7529" stroke="white" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ClusterIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.7772 10.3484H20.9022C20.2487 10.3484 19.7111 10.8778 19.69 11.5236H14.9358V10.179C14.9358 10.0837 14.9042 10.0096 14.8831 9.92493L17.9823 6.81232C18.1088 6.85467 18.2353 6.89702 18.3723 6.89702H19.2472C19.9219 6.89702 20.4701 6.34649 20.4701 5.66891V4.79018C20.4701 4.11261 19.9219 3.56208 19.2472 3.56208H18.3723C17.6977 3.56208 17.1495 4.11261 17.1495 4.79018V5.66891C17.1495 5.81713 17.1811 5.94418 17.2338 6.08181L14.103 9.22618C14.0503 9.22618 13.9976 9.19442 13.9344 9.19442H12.5429V4.31376C13.1648 4.25024 13.6497 3.74206 13.6497 3.10683V2.2281C13.6497 1.55053 13.1016 1 12.4269 1H11.552C10.8773 1 10.3292 1.55053 10.3292 2.2281V3.10683C10.3292 3.76323 10.8457 4.29259 11.4887 4.32435V9.18383H10.3503C10.2554 9.18383 10.1711 9.21559 10.0867 9.23677L6.81888 5.95476C6.86104 5.82772 6.90321 5.70067 6.90321 5.56304V4.68431C6.90321 4.00674 6.35506 3.45621 5.6804 3.45621H4.80546C4.13081 3.45621 3.58266 4.00674 3.58266 4.68431V5.56304C3.58266 6.24062 4.13081 6.79114 4.80546 6.79114H5.6804C5.82798 6.79114 5.95448 6.75938 6.08098 6.70645L9.38045 10.0202C9.38045 10.0731 9.34883 10.1261 9.34883 10.179V11.5236H4.31001C4.27839 10.8672 3.75132 10.3484 3.09775 10.3484H2.22281C1.54816 10.3484 1 10.8989 1 11.5765V12.4552C1 13.1328 1.54816 13.6833 2.22281 13.6833H3.09775C3.73023 13.6833 4.22568 13.1963 4.29947 12.5823H9.34883V13.7786C9.34883 13.8422 9.36991 13.8845 9.38045 13.948L6.09152 17.2512C5.94394 17.1983 5.79636 17.1559 5.62769 17.1559H4.75275C4.0781 17.1559 3.52995 17.7064 3.52995 18.384V19.2628C3.52995 19.9403 4.0781 20.4909 4.75275 20.4909H5.62769C6.30235 20.4909 6.8505 19.9403 6.8505 19.2628V18.384C6.8505 18.2676 6.81888 18.1511 6.77671 18.0452L10.0867 14.7209C10.1711 14.7421 10.2554 14.7738 10.3397 14.7738H11.4782V19.6756C10.8352 19.7074 10.3186 20.2368 10.3186 20.8932V21.7719C10.3186 22.4495 10.8668 23 11.5414 23H12.4164C13.091 23 13.6392 22.4495 13.6392 21.7719V20.8932C13.6392 20.2579 13.1437 19.7498 12.5323 19.6862V14.7738H13.9238C13.9238 14.7738 14.0081 14.7526 14.0609 14.7421L17.2654 17.9711C17.2233 18.0982 17.1811 18.2358 17.1811 18.384V19.2628C17.1811 19.9403 17.7293 20.4909 18.4039 20.4909H19.2789C19.9535 20.4909 20.5017 19.9403 20.5017 19.2628V18.384C20.5017 17.7064 19.9535 17.1559 19.2789 17.1559H18.4039C18.2669 17.1559 18.1404 17.1877 18.0139 17.23L14.862 14.0645C14.8936 13.9692 14.9253 13.8739 14.9253 13.7786V12.5823H19.7005C19.7743 13.1963 20.2698 13.6833 20.9022 13.6833H21.7772C22.4518 13.6833 23 13.1328 23 12.4552V11.5765C23 10.8989 22.4518 10.3484 21.7772 10.3484ZM11.1198 3.10683V2.2281C11.1198 1.9846 11.3095 1.79403 11.552 1.79403H12.4269C12.6694 1.79403 12.8591 1.9846 12.8591 2.2281V3.10683C12.8591 3.35034 12.6694 3.5409 12.4269 3.5409H11.552C11.3095 3.5409 11.1198 3.35034 11.1198 3.10683ZM3.54049 12.4552C3.54049 12.6987 3.35074 12.8893 3.10829 12.8893H2.23335C1.9909 12.8893 1.80115 12.6987 1.80115 12.4552V11.5765C1.80115 11.333 1.9909 11.1424 2.23335 11.1424H3.10829C3.35074 11.1424 3.54049 11.333 3.54049 11.5765V12.4552ZM4.80546 5.99711C4.56301 5.99711 4.37326 5.80654 4.37326 5.56304V4.68431C4.37326 4.44081 4.56301 4.25024 4.80546 4.25024H5.6804C5.92286 4.25024 6.1126 4.44081 6.1126 4.68431V5.56304C6.1126 5.80654 5.92286 5.99711 5.6804 5.99711H4.80546ZM6.07044 19.2733C6.07044 19.5168 5.88069 19.7074 5.63824 19.7074H4.7633C4.52084 19.7074 4.3311 19.5168 4.3311 19.2733V18.3946C4.3311 18.1511 4.52084 17.9605 4.7633 17.9605H5.63824C5.88069 17.9605 6.07044 18.1511 6.07044 18.3946V19.2733ZM12.8591 20.9143V21.7931C12.8591 22.0366 12.6694 22.2271 12.4269 22.2271H11.552C11.3095 22.2271 11.1198 22.0366 11.1198 21.7931V20.9143C11.1198 20.6708 11.3095 20.4803 11.552 20.4803H12.4269C12.6694 20.4803 12.8591 20.6708 12.8591 20.9143ZM17.9401 4.79018C17.9401 4.54668 18.1299 4.35611 18.3723 4.35611H19.2472C19.4897 4.35611 19.6794 4.54668 19.6794 4.79018V5.66891C19.6794 5.91242 19.4897 6.10298 19.2472 6.10298H18.3723C18.1299 6.10298 17.9401 5.91242 17.9401 5.66891V4.79018ZM10.3608 10.2425H13.8922L13.9449 13.7363L10.4135 13.7892L10.3608 10.2425ZM19.2999 17.9605C19.5424 17.9605 19.7321 18.1511 19.7321 18.3946V19.2733C19.7321 19.5168 19.5424 19.7074 19.2999 19.7074H18.425C18.1826 19.7074 17.9928 19.5168 17.9928 19.2733V18.3946C17.9928 18.1511 18.1826 17.9605 18.425 17.9605H19.2999ZM22.2199 12.4552C22.2199 12.6987 22.0302 12.8893 21.7877 12.8893H20.9128C20.6703 12.8893 20.4806 12.6987 20.4806 12.4552V11.5765C20.4806 11.333 20.6703 11.1424 20.9128 11.1424H21.7877C22.0302 11.1424 22.2199 11.333 22.2199 11.5765V12.4552Z" fill="white"/>
  </svg>
);
export function AnnualFailuresIcon() {
  return (
    <svg width="38" height="34" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.98957 34H34.0104C37.0803 34 38.994 30.6615 37.459 28.0026L22.4486 1.99412C20.9137 -0.664707 17.0863 -0.664707 15.5514 1.99412L0.540956 28.0026C-0.993975 30.6615 0.919705 34 3.98957 34ZM19 20.0062C17.9036 20.0062 17.0066 19.1066 17.0066 18.0071V14.0088C17.0066 12.9093 17.9036 12.0097 19 12.0097C20.0964 12.0097 20.9934 12.9093 20.9934 14.0088V18.0071C20.9934 19.1066 20.0964 20.0062 19 20.0062ZM20.9934 28.0026H17.0066V24.0044H20.9934V28.0026Z"
        fill="#FF9C16"
      />
    </svg>
  );
}

export function AvgWorkingHrsIcon() {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.75 30.98C24.25 30.98 22.4625 25.76 20.7337 20.7125C19.0962 15.9275 17.4 10.98 13.75 10.98C12.8976 11.0302 12.0794 11.3331 11.3998 11.85C10.7201 12.3669 10.2098 13.0744 9.93375 13.8825L7.5625 13.085C7.62625 12.8975 9.15125 8.47998 13.75 8.47998C19.1875 8.47998 21.265 14.5487 23.1 19.9025C24.6112 24.3137 26.0375 28.48 28.75 28.48C29.6023 28.4299 30.4203 28.1272 31.0999 27.6105C31.7796 27.0938 32.29 26.3865 32.5662 25.5787L34.9362 26.375C34.8737 26.5625 33.3488 30.98 28.75 30.98Z"
        fill="#E255F2"
      />
      <path
        d="M5 35.98V22.23H7.5V19.73H5V3.47998H2.5V35.98C2.5 36.643 2.76339 37.2789 3.23223 37.7477C3.70107 38.2166 4.33696 38.48 5 38.48H37.5V35.98H5Z"
        fill="#E255F2"
      />
      <path
        d="M10 19.73H12.5V22.23H10V19.73ZM15 19.73H17.5V22.23H15V19.73ZM25 19.73H27.5V22.23H25V19.73ZM30 19.73H32.5V22.23H30V19.73ZM35 19.73H37.5V22.23H35V19.73Z"
        fill="#E255F2"
      />
    </svg>
  );
}

export function DownTimeIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M16.6076 2H7.93758C4.54758 2 2.26758 4.38 2.26758 7.92V16.09C2.26758 19.62 4.54758 22 7.93758 22H16.6076C19.9976 22 22.2676 19.62 22.2676 16.09V7.92C22.2676 4.38 19.9976 2 16.6076 2Z"
        fill="#959DB2"
      />
      <path
        d="M15.841 15.8143C15.71 15.8143 15.578 15.7803 15.457 15.7093L11.531 13.3673C11.305 13.2313 11.166 12.9863 11.166 12.7223V7.67529C11.166 7.26129 11.502 6.92529 11.916 6.92529C12.33 6.92529 12.666 7.26129 12.666 7.67529V12.2963L16.226 14.4193C16.581 14.6323 16.698 15.0923 16.486 15.4483C16.345 15.6833 16.096 15.8143 15.841 15.8143Z"
        fill="#959DB2"
      />
    </svg>
  );
}
export function HospitalNoIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.2675 10.8049H35.183V2.69223C35.183 2.15433 34.9693 1.63845 34.5889 1.2581C34.2086 0.877744 33.6927 0.664063 33.1548 0.664062H10.8449C10.307 0.664063 9.79117 0.877744 9.41081 1.2581C9.03046 1.63845 8.81678 2.15433 8.81678 2.69223V10.8049H2.73227C2.19437 10.8049 1.67849 11.0186 1.29814 11.3989C0.917783 11.7793 0.704102 12.2952 0.704102 12.8331V41.2274C0.704102 41.7653 0.917783 42.2812 1.29814 42.6616C1.67849 43.0419 2.19437 43.2556 2.73227 43.2556H41.2675C41.8054 43.2556 42.3213 43.0419 42.7016 42.6616C43.082 42.2812 43.2957 41.7653 43.2957 41.2274V12.8331C43.2957 12.2952 43.082 11.7793 42.7016 11.3989C42.3213 11.0186 41.8054 10.8049 41.2675 10.8049ZM12.8731 35.1429H10.8449C10.307 35.1429 9.79117 34.9293 9.41081 34.5489C9.03046 34.1685 8.81678 33.6527 8.81678 33.1148C8.81678 32.5769 9.03046 32.061 9.41081 31.6806C9.79117 31.3003 10.307 31.0866 10.8449 31.0866H12.8731C13.411 31.0866 13.9269 31.3003 14.3072 31.6806C14.6876 32.061 14.9013 32.5769 14.9013 33.1148C14.9013 33.6527 14.6876 34.1685 14.3072 34.5489C13.9269 34.9293 13.411 35.1429 12.8731 35.1429ZM12.8731 27.0303H10.8449C10.307 27.0303 9.79117 26.8166 9.41081 26.4362C9.03046 26.0559 8.81678 25.54 8.81678 25.0021C8.81678 24.4642 9.03046 23.9483 9.41081 23.568C9.79117 23.1876 10.307 22.9739 10.8449 22.9739H12.8731C13.411 22.9739 13.9269 23.1876 14.3072 23.568C14.6876 23.9483 14.9013 24.4642 14.9013 25.0021C14.9013 25.54 14.6876 26.0559 14.3072 26.4362C13.9269 26.8166 13.411 27.0303 12.8731 27.0303ZM23.014 35.1429H20.9858C20.4479 35.1429 19.932 34.9293 19.5517 34.5489C19.1713 34.1685 18.9576 33.6527 18.9576 33.1148C18.9576 32.5769 19.1713 32.061 19.5517 31.6806C19.932 31.3003 20.4479 31.0866 20.9858 31.0866H23.014C23.5519 31.0866 24.0677 31.3003 24.4481 31.6806C24.8284 32.061 25.0421 32.5769 25.0421 33.1148C25.0421 33.6527 24.8284 34.1685 24.4481 34.5489C24.0677 34.9293 23.5519 35.1429 23.014 35.1429ZM23.014 27.0303H20.9858C20.4479 27.0303 19.932 26.8166 19.5517 26.4362C19.1713 26.0559 18.9576 25.54 18.9576 25.0021C18.9576 24.4642 19.1713 23.9483 19.5517 23.568C19.932 23.1876 20.4479 22.9739 20.9858 22.9739H23.014C23.5519 22.9739 24.0677 23.1876 24.4481 23.568C24.8284 23.9483 25.0421 24.4642 25.0421 25.0021C25.0421 25.54 24.8284 26.0559 24.4481 26.4362C24.0677 26.8166 23.5519 27.0303 23.014 27.0303ZM25.0421 15.8753H24.028V16.8894C24.028 17.4273 23.8144 17.9432 23.434 18.3235C23.0537 18.7039 22.5378 18.9176 21.9999 18.9176C21.462 18.9176 20.9461 18.7039 20.5657 18.3235C20.1854 17.9432 19.9717 17.4273 19.9717 16.8894V15.8753H18.9576C18.4197 15.8753 17.9038 15.6616 17.5235 15.2813C17.1431 14.9009 16.9295 14.3851 16.9295 13.8472C16.9295 13.3093 17.1431 12.7934 17.5235 12.413C17.9038 12.0327 18.4197 11.819 18.9576 11.819H19.9717V10.8049C19.9717 10.267 20.1854 9.75113 20.5657 9.37078C20.9461 8.99042 21.462 8.77674 21.9999 8.77674C22.5378 8.77674 23.0537 8.99042 23.434 9.37078C23.8144 9.75113 24.028 10.267 24.028 10.8049V11.819H25.0421C25.58 11.819 26.0959 12.0327 26.4763 12.413C26.8566 12.7934 27.0703 13.3093 27.0703 13.8472C27.0703 14.3851 26.8566 14.9009 26.4763 15.2813C26.0959 15.6616 25.58 15.8753 25.0421 15.8753ZM33.1548 35.1429H31.1266C30.5887 35.1429 30.0729 34.9293 29.6925 34.5489C29.3121 34.1685 29.0985 33.6527 29.0985 33.1148C29.0985 32.5769 29.3121 32.061 29.6925 31.6806C30.0729 31.3003 30.5887 31.0866 31.1266 31.0866H33.1548C33.6927 31.0866 34.2086 31.3003 34.5889 31.6806C34.9693 32.061 35.183 32.5769 35.183 33.1148C35.183 33.6527 34.9693 34.1685 34.5889 34.5489C34.2086 34.9293 33.6927 35.1429 33.1548 35.1429ZM33.1548 27.0303H31.1266C30.5887 27.0303 30.0729 26.8166 29.6925 26.4362C29.3121 26.0559 29.0985 25.54 29.0985 25.0021C29.0985 24.4642 29.3121 23.9483 29.6925 23.568C30.0729 23.1876 30.5887 22.9739 31.1266 22.9739H33.1548C33.6927 22.9739 34.2086 23.1876 34.5889 23.568C34.9693 23.9483 35.183 24.4642 35.183 25.0021C35.183 25.54 34.9693 26.0559 34.5889 26.4362C34.2086 26.8166 33.6927 27.0303 33.1548 27.0303Z"
        fill="#38C793"
      />
    </svg>
  );
}

export function TotalSitesCardIcon() {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 24.7158H12C13.0609 24.7158 14.0783 25.1372 14.8284 25.8874C15.5786 26.6375 16 27.655 16 28.7158V36.7158C16 37.7767 15.5786 38.7941 14.8284 39.5442C14.0783 40.2944 13.0609 40.7158 12 40.7158H4C2.93913 40.7158 1.92172 40.2944 1.17157 39.5442C0.421427 38.7941 0 37.7767 0 36.7158V28.7158C0 27.655 0.421427 26.6375 1.17157 25.8874C1.92172 25.1372 2.93913 24.7158 4 24.7158ZM16 0.71582H24C25.0609 0.71582 26.0783 1.13725 26.8284 1.88739C27.5786 2.63754 28 3.65495 28 4.71582V12.7158C28 13.7767 27.5786 14.7941 26.8284 15.5442C26.0783 16.2944 25.0609 16.7158 24 16.7158H16C14.9391 16.7158 13.9217 16.2944 13.1716 15.5442C12.4214 14.7941 12 13.7767 12 12.7158V4.71582C12 3.65495 12.4214 2.63754 13.1716 1.88739C13.9217 1.13725 14.9391 0.71582 16 0.71582ZM28 24.7158H36C37.0609 24.7158 38.0783 25.1372 38.8284 25.8874C39.5786 26.6375 40 27.655 40 28.7158V36.7158C40 37.7767 39.5786 38.7941 38.8284 39.5442C38.0783 40.2944 37.0609 40.7158 36 40.7158H28C26.9391 40.7158 25.9217 40.2944 25.1716 39.5442C24.4214 38.7941 24 37.7767 24 36.7158V28.7158C24 27.655 24.4214 26.6375 25.1716 25.8874C25.9217 25.1372 26.9391 24.7158 28 24.7158Z"
        fill="#35B9E9"
      />
      <path
        d="M18 18.7158V14.7158H22V22.7158H12C11.4696 22.7158 10.9609 22.9265 10.5858 23.3016C10.2107 23.6767 10 24.1854 10 24.7158V26.5858H6V24.7158C6 23.1245 6.63214 21.5984 7.75736 20.4732C8.88258 19.348 10.4087 18.7158 12 18.7158H18Z"
        fill="#35B9E9"
      />
      <path
        d="M20 22.7158V18.7158H28C29.5913 18.7158 31.1174 19.348 32.2426 20.4732C33.3679 21.5984 34 23.1245 34 24.7158V26.7558H30V24.7158C30 24.1854 29.7893 23.6767 29.4142 23.3016C29.0391 22.9265 28.5304 22.7158 28 22.7158H20Z"
        fill="#35B9E9"
      />
    </svg>
  );
}

export function WorkOrderCardIcon() {
  return (
    <svg width="33" height="42" viewBox="0 0 33 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="33" height="42" rx="4" fill="#375DFB" />
      <path
        d="M17 31.9998C17.5523 31.9998 18 32.4475 18 32.9998C18 33.552 17.5523 33.9998 17 33.9998H10C9.44772 33.9998 9 33.552 9 32.9998C9 32.4475 9.44772 31.9998 10 31.9998H17ZM24 25.9998C24.5523 25.9998 25 26.4475 25 26.9998C25 27.552 24.5523 27.9998 24 27.9998H10C9.44772 27.9998 9 27.552 9 26.9998C9 26.4475 9.44772 25.9998 10 25.9998H24ZM22.3691 9.22437C22.7619 8.90402 23.3409 8.92662 23.707 9.29273C24.0731 9.65885 24.0957 10.2379 23.7754 10.6306L23.707 10.7068L15.707 18.7068C15.3165 19.0973 14.6835 19.0973 14.293 18.7068L10.293 14.7068L10.2246 14.6306C9.90426 14.2379 9.92685 13.6589 10.293 13.2927C10.6591 12.9266 11.2381 12.904 11.6309 13.2244L11.707 13.2927L15 16.5857L22.293 9.29273L22.3691 9.22437Z"
        fill="#EBF1FF"
      />
    </svg>
  );
}

export const SubDepartmentIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.2857 13.0054H21.0484C20.8547 13.0054 20.6758 13.0501 20.4969 13.1097L16.0398 8.65258C16.0845 8.51842 16.1292 8.38426 16.1292 8.2501V3.18178C16.1292 2.40662 15.5031 1.76562 14.713 1.76562H9.64472C8.86956 1.76562 8.22857 2.40662 8.22857 3.18178V8.2501C8.22857 8.33954 8.25839 8.39917 8.27329 8.48861L3.62236 13.1395C3.41366 13.065 3.20497 13.0054 2.96646 13.0054H1.72919C0.775155 13.0054 0 13.7805 0 14.7346V15.9718C0 16.9259 0.775155 17.701 1.72919 17.701H2.96646C3.9205 17.701 4.69565 16.9259 4.69565 15.9718V14.7346C4.69565 14.5706 4.65093 14.4066 4.5913 14.2575L9.27205 9.57681C9.3913 9.60662 9.51056 9.65134 9.62981 9.65134H11.2398V16.5532C10.3304 16.5979 9.6 17.3433 9.6 18.2675V19.5048C9.6 20.4588 10.3752 21.2339 11.3292 21.2339H12.5665C13.5205 21.2339 14.2957 20.4588 14.2957 19.5048V18.2675C14.2957 17.3731 13.595 16.6576 12.7304 16.5681V9.65134H14.6981C14.6981 9.65134 14.8174 9.62153 14.8919 9.60662L19.4236 14.1532C19.364 14.3321 19.3043 14.5259 19.3043 14.7346V15.9718C19.3043 16.9259 20.0795 17.701 21.0335 17.701H22.2708C23.2248 17.701 24 16.9259 24 15.9718V14.7346C24 13.7805 23.2248 13.0054 22.2708 13.0054H22.2857ZM3.57764 15.9718C3.57764 16.3147 3.30932 16.583 2.96646 16.583H1.72919C1.38634 16.583 1.11801 16.3147 1.11801 15.9718V14.7346C1.11801 14.3917 1.38634 14.1234 1.72919 14.1234H2.96646C3.30932 14.1234 3.57764 14.3917 3.57764 14.7346V15.9718ZM13.1776 18.2824V19.5197C13.1776 19.8625 12.9093 20.1308 12.5665 20.1308H11.3292C10.9863 20.1308 10.718 19.8625 10.718 19.5197V18.2824C10.718 17.9395 10.9863 17.6712 11.3292 17.6712H12.5665C12.9093 17.6712 13.1776 17.9395 13.1776 18.2824ZM9.64472 3.25631H14.6385L14.713 8.17556L9.71925 8.2501L9.64472 3.25631ZM22.8969 15.9718C22.8969 16.3147 22.6286 16.583 22.2857 16.583H21.0484C20.7056 16.583 20.4373 16.3147 20.4373 15.9718V14.7346C20.4373 14.3917 20.7056 14.1234 21.0484 14.1234H22.2857C22.6286 14.1234 22.8969 14.3917 22.8969 14.7346V15.9718Z" fill="white"/>
  </svg>
);

export function UserCommentsIcon(){
  return (
    <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M27.5125 1.25C23.8813 1.25 21.25 4.2125 21.25 7.5C21.25 8.55 21.5563 9.63125 22.0938 10.6187C22.1938 10.7812 22.2062 10.9875 22.1375 11.1813L21.7188 12.5812C21.625 12.9187 21.9125 13.1687 22.2313 13.0688L23.4937 12.6937C23.8375 12.5812 24.1062 12.725 24.4256 12.9187C25.3381 13.4563 26.475 13.7312 27.5 13.7312C30.6 13.7312 33.75 11.3375 33.75 7.48125C33.75 4.15625 31.0625 1.25 27.5125 1.25Z"
        fill="#31CD82"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.4879 8.30632C27.0441 8.30007 26.6879 7.94382 26.6879 7.50007C26.6879 7.06257 27.0504 6.70007 27.4879 6.70632C27.9316 6.70632 28.2879 7.06257 28.2879 7.50632C28.2879 7.94382 27.9316 8.30632 27.4879 8.30632ZM24.6064 8.30637C24.1689 8.30637 23.8064 7.94387 23.8064 7.50637C23.8064 7.06262 24.1626 6.70637 24.6064 6.70637C25.0501 6.70637 25.4064 7.06262 25.4064 7.50637C25.4064 7.94387 25.0501 8.30012 24.6064 8.30637ZM29.569 7.50632C29.569 7.94382 29.9253 8.30632 30.369 8.30632C30.8128 8.30632 31.169 7.94382 31.169 7.50632C31.169 7.06257 30.8128 6.70632 30.369 6.70632C29.9253 6.70632 29.569 7.06257 29.569 7.50632Z"
        fill="#31CD82"
      />
      <path
        d="M11.9968 15.1746C7.68376 15.1746 3.99976 15.8546 3.99976 18.5746C3.99976 21.2956 7.66076 21.9996 11.9968 21.9996C16.3098 21.9996 19.9938 21.3206 19.9938 18.5996C19.9938 15.8786 16.3338 15.1746 11.9968 15.1746Z"
        fill="#31CD82"
      />
      <path
        opacity="0.4"
        d="M11.9968 12.5837C14.9348 12.5837 17.2888 10.2287 17.2888 7.29169C17.2888 4.35469 14.9348 1.99969 11.9968 1.99969C9.05983 1.99969 6.70483 4.35469 6.70483 7.29169C6.70483 10.2287 9.05983 12.5837 11.9968 12.5837Z"
        fill="#31CD82"
      />
    </svg>
  );
}

export function StarIcon(){
  return(
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="36" rx="18" fill="#2A347B" />
    <rect x="6" y="6" width="24" height="24" rx="12" fill="#2A347B" />
    <path
      opacity="0.4"
      d="M18.9763 9.11361L21.2028 13.5879C21.3668 13.9121 21.6799 14.1372 22.041 14.1872L27.042 14.9156C27.3341 14.9566 27.5992 15.1107 27.7782 15.3458C27.9552 15.5779 28.0312 15.8721 27.9882 16.1612C27.9532 16.4013 27.8402 16.6234 27.6672 16.7935L24.0434 20.3063C23.7783 20.5514 23.6583 20.9146 23.7223 21.2698L24.6145 26.2083C24.7095 26.8046 24.3144 27.3669 23.7223 27.48C23.4783 27.519 23.2282 27.478 23.0082 27.3659L18.5472 25.0417C18.2161 24.8746 17.8251 24.8746 17.494 25.0417L13.033 27.3659C12.4849 27.657 11.8058 27.4589 11.5007 26.9187C11.3877 26.7036 11.3477 26.4584 11.3847 26.2193L12.2769 21.2798C12.3409 20.9256 12.2199 20.5604 11.9558 20.3153L8.33202 16.8045C7.90092 16.3883 7.88792 15.703 8.30301 15.2717C8.31201 15.2627 8.32201 15.2527 8.33202 15.2427C8.50405 15.0676 8.7301 14.9566 8.97415 14.9276L13.9752 14.1982C14.3353 14.1472 14.6484 13.9241 14.8134 13.5979L16.9599 9.11361C17.1509 8.72942 17.547 8.4903 17.9771 8.5003H18.1111C18.4842 8.54533 18.8093 8.77644 18.9763 9.11361Z"
      fill="white"
    />
    <path
      d="M17.992 24.9171C17.7983 24.9231 17.6096 24.9752 17.4399 25.0682L13.0007 27.3871C12.4576 27.6464 11.8076 27.4452 11.503 26.9258C11.3902 26.7136 11.3493 26.4704 11.3872 26.2322L12.2738 21.3032C12.3338 20.9449 12.2139 20.5806 11.9533 20.3284L8.32794 16.8185C7.8976 16.3971 7.88961 15.7056 8.31096 15.2742C8.31695 15.2682 8.32195 15.2632 8.32794 15.2582C8.49967 15.0881 8.72133 14.976 8.95996 14.9409L13.9652 14.2043C14.3277 14.1583 14.6422 13.9321 14.8019 13.6038L16.9776 9.06312C17.1843 8.69682 17.5806 8.47864 18 8.50166C17.992 8.7989 17.992 24.715 17.992 24.9171Z"
      fill="white"
    />
  </svg>
  )

}



export function FeedbackIcon(){
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M12.9763 3.11361L15.2028 7.58789C15.3668 7.91205 15.6799 8.13717 16.041 8.18719L21.042 8.91556C21.3341 8.95658 21.5992 9.11066 21.7782 9.34578C21.9552 9.5779 22.0312 9.87205 21.9882 10.1612C21.9532 10.4013 21.8402 10.6234 21.6672 10.7935L18.0434 14.3063C17.7783 14.5514 17.6583 14.9146 17.7223 15.2698L18.6145 20.2083C18.7095 20.8046 18.3144 21.3669 17.7223 21.48C17.4783 21.519 17.2282 21.478 17.0082 21.3659L12.5472 19.0417C12.2161 18.8746 11.8251 18.8746 11.494 19.0417L7.03303 21.3659C6.48491 21.657 5.80576 21.4589 5.5007 20.9187C5.38767 20.7036 5.34766 20.4584 5.38467 20.2193L6.27686 15.2798C6.34088 14.9256 6.21985 14.5604 5.95579 14.3153L2.33202 10.8045C1.90092 10.3883 1.88792 9.70296 2.30301 9.27175C2.31201 9.26274 2.32201 9.25274 2.33202 9.24273C2.50405 9.06764 2.7301 8.95658 2.97415 8.92757L7.97523 8.1982C8.33531 8.14717 8.64837 7.92406 8.81341 7.59789L10.9599 3.11361C11.1509 2.72942 11.547 2.4903 11.9771 2.5003H12.1111C12.4842 2.54533 12.8093 2.77644 12.9763 3.11361Z"
        fill="#2A347B"
      />
      <path
        d="M11.992 18.9171C11.7983 18.9231 11.6096 18.9752 11.4399 19.0682L7.00072 21.3871C6.45756 21.6464 5.80756 21.4452 5.50303 20.9258C5.39021 20.7136 5.34927 20.4704 5.38721 20.2322L6.27384 15.3032C6.33375 14.9449 6.21394 14.5806 5.95334 14.3284L2.32794 10.8185C1.8976 10.3971 1.88961 9.70556 2.31096 9.27421C2.31695 9.26821 2.32195 9.2632 2.32794 9.2582C2.49967 9.08806 2.72133 8.97597 2.95996 8.94094L7.96523 8.20433C8.32767 8.1583 8.64219 7.93211 8.80194 7.60384L10.9776 3.06312C11.1843 2.69682 11.5806 2.47864 12 2.50166C11.992 2.7989 11.992 18.715 11.992 18.9171Z"
        fill="#2A347B"
      />
    </svg>

    // <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     opacity="0.4"
    //     d="M12.9763 3.11361L15.2028 7.58789C15.3668 7.91205 15.6799 8.13717 16.041 8.18719L21.042 8.91556C21.3341 8.95658 21.5992 9.11066 21.7782 9.34578C21.9552 9.5779 22.0312 9.87205 21.9882 10.1612C21.9532 10.4013 21.8402 10.6234 21.6672 10.7935L18.0434 14.3063C17.7783 14.5514 17.6583 14.9146 17.7223 15.2698L18.6145 20.2083C18.7095 20.8046 18.3144 21.3669 17.7223 21.48C17.4783 21.519 17.2282 21.478 17.0082 21.3659L12.5472 19.0417C12.2161 18.8746 11.8251 18.8746 11.494 19.0417L7.03303 21.3659C6.48491 21.657 5.80576 21.4589 5.5007 20.9187C5.38767 20.7036 5.34766 20.4584 5.38467 20.2193L6.27686 15.2798C6.34088 14.9256 6.21985 14.5604 5.95579 14.3153L2.33202 10.8045C1.90092 10.3883 1.88792 9.70296 2.30301 9.27175C2.31201 9.26274 2.32201 9.25274 2.33202 9.24273C2.50405 9.06764 2.7301 8.95658 2.97415 8.92757L7.97523 8.1982C8.33531 8.14717 8.64837 7.92406 8.81341 7.59789L10.9599 3.11361C11.1509 2.72942 11.547 2.4903 11.9771 2.5003H12.1111C12.4842 2.54533 12.8093 2.77644 12.9763 3.11361Z"
    //     fill="#2A347B"
    //   />
    //   <path
    //     d="M11.992 18.9171C11.7983 18.9231 11.6096 18.9752 11.4399 19.0682L7.00072 21.3871C6.45756 21.6464 5.80756 21.4452 5.50303 20.9258C5.39021 20.7136 5.34927 20.4704 5.38721 20.2322L6.27384 15.3032C6.33375 14.9449 6.21394 14.5806 5.95334 14.3284L2.32794 10.8185C1.8976 10.3971 1.88961 9.70556 2.31096 9.27421C2.31695 9.26821 2.32195 9.2632 2.32794 9.2582C2.49967 9.08806 2.72133 8.97597 2.95996 8.94094L7.96523 8.20433C8.32767 8.1583 8.64219 7.93211 8.80194 7.60384L10.9776 3.06312C11.1843 2.69682 11.5806 2.47864 12 2.50166C11.992 2.7989 11.992 18.715 11.992 18.9171Z"
    //     fill="#2A347B"
    //   />
    // </svg>
  );
}

export function SystemFeedbackIcon(){
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.66295 13.2016C10.0114 13.2016 11.9153 11.2977 11.9153 8.94925C11.9153 6.60076 10.0114 4.69702 7.66295 4.69702C5.31447 4.69702 3.41064 6.60076 3.41064 8.94925C3.41064 11.2977 5.31447 13.2016 7.66295 13.2016Z" fill="#2A347B"/>
      <path d="M12.5538 21.3897C14.0321 21.3897 14.8898 19.7472 14.0686 18.5245C12.8275 16.6812 10.4185 15.4402 7.66272 15.4402C4.90693 15.4402 2.4979 16.6812 1.25688 18.5245C0.435618 19.7472 1.29338 21.3897 2.77165 21.3897H12.5538Z" fill="#2A347B"/>
      <path opacity="0.4" d="M20.7146 2.61035C21.9521 2.61035 22.9659 3.56772 23.0555 4.78204L23.0619 4.95718V7.30401C23.0619 8.54121 22.1043 9.55482 20.8898 9.6444L20.7146 9.65084H18.9528L17.5467 11.5281C16.9254 12.3567 15.6635 12.021 15.4614 11.0874L15.4407 10.9564L15.4338 10.8243L15.4329 9.57457L15.3418 9.55148C14.4904 9.29512 13.8428 8.5684 13.7012 7.6734L13.6788 7.47916L13.6724 7.30401V4.95718C13.6724 3.71998 14.63 2.70637 15.8445 2.61679L16.0198 2.61035H20.7146Z" fill="#2A347B"/>
    </svg>

  );
}

export function FeedbackCommentIcon(){
  return (
    <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.4" d="M27.5125 1.25C23.8813 1.25 21.25 4.2125 21.25 7.5C21.25 8.55 21.5563 9.63125 22.0938 10.6187C22.1938 10.7812 22.2062 10.9875 22.1375 11.1813L21.7188 12.5812C21.625 12.9187 21.9125 13.1687 22.2313 13.0688L23.4937 12.6937C23.8375 12.5812 24.1062 12.725 24.4256 12.9187C25.3381 13.4563 26.475 13.7312 27.5 13.7312C30.6 13.7312 33.75 11.3375 33.75 7.48125C33.75 4.15625 31.0625 1.25 27.5125 1.25Z" fill="#31CD82"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M27.4877 8.30638C27.0439 8.30013 26.6877 7.94388 26.6877 7.50013C26.6877 7.06263 27.0502 6.70013 27.4877 6.70638C27.9314 6.70638 28.2877 7.06263 28.2877 7.50638C28.2877 7.94388 27.9314 8.30638 27.4877 8.30638ZM24.6062 8.30643C24.1687 8.30643 23.8062 7.94393 23.8062 7.50643C23.8062 7.06268 24.1624 6.70643 24.6062 6.70643C25.0499 6.70643 25.4062 7.06268 25.4062 7.50643C25.4062 7.94393 25.0499 8.30018 24.6062 8.30643ZM29.5688 7.50638C29.5688 7.94388 29.925 8.30638 30.3688 8.30638C30.8125 8.30638 31.1688 7.94388 31.1688 7.50638C31.1688 7.06263 30.8125 6.70638 30.3688 6.70638C29.925 6.70638 29.5688 7.06263 29.5688 7.50638Z" fill="#31CD82"/>
      <path d="M11.997 15.1746C7.684 15.1746 4 15.8546 4 18.5746C4 21.2956 7.661 21.9996 11.997 21.9996C16.31 21.9996 19.994 21.3206 19.994 18.5996C19.994 15.8786 16.334 15.1746 11.997 15.1746Z" fill="#31CD82"/>
      <path opacity="0.4" d="M11.9971 12.5838C14.9351 12.5838 17.2891 10.2288 17.2891 7.29176C17.2891 4.35476 14.9351 1.99976 11.9971 1.99976C9.06008 1.99976 6.70508 4.35476 6.70508 7.29176C6.70508 10.2288 9.06008 12.5838 11.9971 12.5838Z" fill="#31CD82"/>
    </svg>
  );
}

export function RateStarIcon(){
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.63539 11.9143L7.59555 13.7198C7.66629 13.8506 7.8013 13.9414 7.95702 13.9616L10.1137 14.2555C10.2397 14.272 10.354 14.3342 10.4312 14.4291C10.5075 14.5227 10.5403 14.6414 10.5218 14.7581C10.5067 14.855 10.4579 14.9446 10.3833 15.0133L8.82057 16.4307C8.70626 16.5296 8.6545 16.6762 8.68211 16.8195L9.06686 18.8122C9.10784 19.0528 8.93746 19.2797 8.68211 19.3253C8.57686 19.3411 8.46902 19.3245 8.37413 19.2793L6.45034 18.3415C6.30757 18.2741 6.13891 18.2741 5.99614 18.3415L4.07235 19.2793C3.83597 19.3968 3.54309 19.3168 3.41153 19.0988C3.36279 19.012 3.34554 18.9131 3.3615 18.8166L3.74625 16.8235C3.77386 16.6806 3.72167 16.5332 3.60779 16.4343L2.04504 15.0177C1.85913 14.8498 1.85352 14.5732 2.03253 14.3992C2.03641 14.3956 2.04072 14.3915 2.04504 14.3875C2.11923 14.3168 2.21671 14.272 2.32196 14.2603L4.47867 13.966C4.63396 13.9454 4.76897 13.8554 4.84014 13.7238L5.7658 11.9143C5.84819 11.7593 6.019 11.6628 6.20447 11.6669H6.26227C6.42316 11.685 6.56335 11.7783 6.63539 11.9143Z" fill="#959DB2"/>
      <path d="M18.1351 11.9143L19.0953 13.7198C19.1661 13.8506 19.3011 13.9414 19.4568 13.9616L21.6135 14.2555C21.7394 14.272 21.8537 14.3342 21.931 14.4291C22.0073 14.5227 22.0401 14.6414 22.0215 14.7581C22.0064 14.855 21.9577 14.9446 21.8831 15.0133L20.3203 16.4307C20.206 16.5296 20.1543 16.6762 20.1819 16.8195L20.5666 18.8122C20.6076 19.0528 20.4372 19.2797 20.1819 19.3253C20.0766 19.3411 19.9688 19.3245 19.8739 19.2793L17.9501 18.3415C17.8073 18.2741 17.6387 18.2741 17.4959 18.3415L15.5721 19.2793C15.3357 19.3968 15.0428 19.3168 14.9113 19.0988C14.8625 19.012 14.8453 18.9131 14.8613 18.8166L15.246 16.8235C15.2736 16.6806 15.2214 16.5332 15.1075 16.4343L13.5448 15.0177C13.3589 14.8498 13.3533 14.5732 13.5323 14.3992C13.5362 14.3956 13.5405 14.3915 13.5448 14.3875C13.619 14.3168 13.7165 14.272 13.8217 14.2603L15.9784 13.966C16.1337 13.9454 16.2687 13.8554 16.3399 13.7238L17.2656 11.9143C17.3479 11.7593 17.5188 11.6628 17.7042 11.6669H17.762C17.9229 11.685 18.0631 11.7783 18.1351 11.9143Z" fill="#959DB2"/>
      <path d="M12.3854 4.2476L13.3456 6.05301C13.4163 6.18381 13.5513 6.27465 13.707 6.29483L15.8637 6.58874C15.9897 6.60529 16.104 6.66746 16.1812 6.76233C16.2575 6.85599 16.2903 6.97469 16.2718 7.09136C16.2567 7.18825 16.2079 7.27788 16.1333 7.34651L14.5706 8.76395C14.4563 8.86286 14.4045 9.00941 14.4321 9.15272L14.8169 11.1455C14.8578 11.3861 14.6875 11.613 14.4321 11.6586C14.3269 11.6743 14.219 11.6578 14.1241 11.6126L12.2003 10.6747C12.0576 10.6073 11.8889 10.6073 11.7461 10.6747L9.82235 11.6126C9.58597 11.73 9.29309 11.6501 9.16153 11.4321C9.11279 11.3453 9.09554 11.2464 9.1115 11.1499L9.49625 9.15676C9.52386 9.01385 9.47167 8.86649 9.35779 8.76758L7.79504 7.35095C7.60913 7.183 7.60352 6.90646 7.78253 6.73246C7.78641 6.72883 7.79072 6.72479 7.79504 6.72075C7.86923 6.6501 7.96671 6.60529 8.07196 6.59358L10.2287 6.29927C10.384 6.27868 10.519 6.18866 10.5901 6.05704L11.5158 4.2476C11.5982 4.09257 11.769 3.99608 11.9545 4.00012H12.0123C12.1732 4.01829 12.3134 4.11155 12.3854 4.2476Z" fill="#959DB2"/>
    </svg>
  );
}


export function Overview() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1528 5.55553C10.2037 5.65919 10.2373 5.77021 10.2524 5.88434L10.5308 10.0243L10.669 12.1051C10.6705 12.3191 10.704 12.5317 10.7687 12.736C10.9356 13.1326 11.3372 13.3846 11.7741 13.367L18.4313 12.9315C18.7196 12.9268 18.998 13.0346 19.2052 13.2313C19.3779 13.3952 19.4894 13.6096 19.5246 13.8402L19.5364 13.9802C19.2609 17.7949 16.4592 20.9767 12.6524 21.798C8.84555 22.6193 4.94186 20.8843 3.06071 17.5349C2.51839 16.5618 2.17965 15.4923 2.06438 14.389C2.01623 14.0624 1.99503 13.7325 2.00098 13.4025C1.99503 9.31273 4.90747 5.77696 8.98433 4.92457C9.47501 4.84816 9.95603 5.10792 10.1528 5.55553Z"
        fill="#1A355E"
      />
      <path
        opacity="0.4"
        d="M12.87 2.00082C17.4299 2.11683 21.2623 5.39579 22 9.81229L21.993 9.84488L21.9728 9.89227L21.9756 10.0224C21.9652 10.1947 21.8986 10.3605 21.784 10.4945C21.6645 10.634 21.5013 10.729 21.3216 10.7659L21.212 10.7809L13.5312 11.2786C13.2757 11.3038 13.0213 11.2214 12.8314 11.052C12.673 10.9107 12.5718 10.7201 12.5432 10.5147L12.0277 2.84506C12.0187 2.81913 12.0187 2.79102 12.0277 2.76508C12.0347 2.55367 12.1278 2.35384 12.286 2.21023C12.4443 2.06662 12.6547 1.9912 12.87 2.00082Z"
        fill="#1A355E"
      />
    </svg>
  );
}

export function Setting() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2836 16.1827C12.9787 16.1827 11.9231 15.1685 11.9231 13.8947C11.9231 12.6209 12.9787 11.5986 14.2836 11.5986C15.5885 11.5986 16.6191 12.6209 16.6191 13.8947C16.6191 15.1685 15.5885 16.1827 14.2836 16.1827Z"
        fill="#959DB2"
      />
      <path
        opacity="0.4"
        d="M21.7805 15.8095C21.6226 15.566 21.3982 15.3226 21.1073 15.1685C20.8746 15.0549 20.725 14.8683 20.592 14.6492C20.1681 13.9515 20.4175 13.0347 21.1239 12.6209C21.9551 12.1584 22.221 11.128 21.739 10.3248L21.1821 9.36738C20.7084 8.56415 19.6694 8.28018 18.8466 8.75076C18.1152 9.14021 17.176 8.88058 16.7521 8.19094C16.6191 7.96376 16.5443 7.72036 16.5609 7.47695C16.5859 7.16053 16.4861 6.86033 16.3365 6.61693C16.029 6.1139 15.4721 5.77313 14.8571 5.77313H13.6852C13.0784 5.78936 12.5216 6.1139 12.214 6.61693C12.0561 6.86033 11.9647 7.16053 11.9813 7.47695C11.998 7.72036 11.9231 7.96376 11.7902 8.19094C11.3663 8.88058 10.4271 9.14021 9.70399 8.75076C8.87284 8.28018 7.84222 8.56415 7.36016 9.36738L6.80329 10.3248C6.32954 11.128 6.59551 12.1584 7.41834 12.6209C8.12481 13.0347 8.37416 13.9515 7.95858 14.6492C7.81729 14.8683 7.66768 15.0549 7.43496 15.1685C7.15237 15.3226 6.90303 15.566 6.77005 15.8095C6.46252 16.3125 6.47915 16.9453 6.78667 17.4727L7.36016 18.4463C7.66768 18.9656 8.24117 19.2901 8.8396 19.2901C9.12219 19.2901 9.45465 19.209 9.72061 19.0467C9.9284 18.9088 10.1777 18.8601 10.452 18.8601C11.2749 18.8601 11.9647 19.5335 11.9813 20.3367C11.9813 21.2698 12.746 22 13.7101 22H14.8405C15.7963 22 16.5609 21.2698 16.5609 20.3367C16.5859 19.5335 17.2757 18.8601 18.0986 18.8601C18.3645 18.8601 18.6139 18.9088 18.83 19.0467C19.0959 19.209 19.4201 19.2901 19.711 19.2901C20.3011 19.2901 20.8746 18.9656 21.1821 18.4463L21.7639 17.4727C22.0631 16.9291 22.0881 16.3125 21.7805 15.8095Z"
        fill="#959DB2"
      />
      <path
        d="M8.12755 6.03716C8.06403 5.93925 7.97376 5.84134 7.85674 5.77933C7.76313 5.73364 7.70295 5.65858 7.64946 5.57046C7.47895 5.28978 7.57925 4.92099 7.86343 4.75454C8.19776 4.56851 8.30475 4.15402 8.11084 3.83092L7.88683 3.44581C7.69626 3.1227 7.27835 3.00848 6.94736 3.19777C6.65315 3.35442 6.27535 3.24999 6.10484 2.97257C6.05135 2.88119 6.02126 2.78328 6.02794 2.68537C6.03797 2.55809 5.99785 2.43733 5.93767 2.33942C5.81397 2.13707 5.58997 2 5.34256 2H4.87115C4.62709 2.00653 4.40309 2.13707 4.27938 2.33942C4.21586 2.43733 4.17908 2.55809 4.18577 2.68537C4.19246 2.78328 4.16237 2.88119 4.10887 2.97257C3.93836 3.24999 3.56057 3.35442 3.2697 3.19777C2.93536 3.00848 2.52079 3.1227 2.32688 3.44581L2.10288 3.83092C1.91231 4.15402 2.01929 4.56851 2.35028 4.75454C2.63446 4.92099 2.73476 5.28978 2.5676 5.57046C2.51076 5.65858 2.45058 5.73364 2.35697 5.77933C2.24329 5.84134 2.143 5.93925 2.0895 6.03716C1.9658 6.23951 1.97249 6.49408 2.09619 6.70622L2.32688 7.09786C2.45058 7.30673 2.68127 7.43728 2.92199 7.43728C3.03566 7.43728 3.1694 7.40464 3.27638 7.33937C3.35997 7.28389 3.46027 7.26431 3.5706 7.26431C3.90159 7.26431 4.17908 7.53519 4.18577 7.8583C4.18577 8.23362 4.49336 8.52735 4.88118 8.52735H5.33587C5.72036 8.52735 6.02794 8.23362 6.02794 7.8583C6.03797 7.53519 6.31547 7.26431 6.64646 7.26431C6.75345 7.26431 6.85375 7.28389 6.94067 7.33937C7.04766 7.40464 7.17805 7.43728 7.29507 7.43728C7.53244 7.43728 7.76313 7.30673 7.88683 7.09786L8.12087 6.70622C8.24123 6.48755 8.25126 6.23951 8.12755 6.03716Z"
        fill="#959DB2"
      />
      <path
        d="M5.11189 6.1873C4.58699 6.1873 4.16238 5.77934 4.16238 5.26694C4.16238 4.75455 4.58699 4.34332 5.11189 4.34332C5.63679 4.34332 6.05137 4.75455 6.05137 5.26694C6.05137 5.77934 5.63679 6.1873 5.11189 6.1873Z"
        fill="#D5D8E0"
      />
    </svg>
  );
}

export function Clock() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.34 1.99982H7.67C4.28 1.99982 2 4.37982 2 7.91982V16.0898C2 19.6198 4.28 21.9998 7.67 21.9998H16.34C19.73 21.9998 22 19.6198 22 16.0898V7.91982C22 4.37982 19.73 1.99982 16.34 1.99982Z"
        fill="#959DB2"
      />
      <path
        d="M15.5734 15.8143C15.4424 15.8143 15.3104 15.7803 15.1894 15.7093L11.2634 13.3673C11.0374 13.2313 10.8984 12.9863 10.8984 12.7223V7.67529C10.8984 7.26129 11.2344 6.92529 11.6484 6.92529C12.0624 6.92529 12.3984 7.26129 12.3984 7.67529V12.2963L15.9584 14.4193C16.3134 14.6323 16.4304 15.0923 16.2184 15.4483C16.0774 15.6833 15.8284 15.8143 15.5734 15.8143Z"
        fill="#959DB2"
      />
    </svg>
  );
}

export function GeoMap() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.88 20.9401C18.93 21.6401 17.68 22.0001 16.19 22.0001H7.81C7.57 22.0001 7.33001 21.9901 7.10001 21.9601L14 15.0601L19.88 20.9401Z"
        fill="#959DB2"
      />
      <path
        opacity="0.4"
        d="M22 7.80997V16.19C22 17.68 21.64 18.93 20.94 19.88L15.06 14L21.96 7.09998C21.99 7.32998 22 7.56997 22 7.80997Z"
        fill="#959DB2"
      />
      <path
        opacity="0.4"
        d="M15.06 14L20.94 19.88C20.65 20.3 20.3 20.65 19.88 20.94L14 15.06L7.10001 21.96C6.46001 21.92 5.88001 21.79 5.35001 21.59C3.21001 20.81 2 18.91 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.19C18.91 2 20.81 3.21 21.59 5.35C21.79 5.88 21.92 6.46 21.96 7.1L15.06 14Z"
        fill="#959DB2"
      />
      <path
        d="M15.06 14L20.94 19.88C20.65 20.3 20.3 20.65 19.88 20.94L14 15.06L7.10001 21.96C6.46001 21.92 5.88001 21.79 5.35001 21.59L5.73999 21.2L21.59 5.34998C21.79 5.87998 21.92 6.45998 21.96 7.09998L15.06 14Z"
        fill="#959DB2"
      />
      <path
        d="M12.24 7.93003C11.86 6.28003 10.4 5.54003 9.11999 5.53003C7.83999 5.53003 6.38 6.27003 6 7.92003C5.58 9.75003 6.69999 11.28 7.70999 12.24C8.10999 12.62 8.60999 12.8 9.11999 12.8C9.62999 12.8 10.13 12.61 10.53 12.24C11.54 11.28 12.66 9.75003 12.24 7.93003ZM9.14999 9.49003C8.59999 9.49003 8.14999 9.04003 8.14999 8.49003C8.14999 7.94003 8.58999 7.49003 9.14999 7.49003H9.16C9.71 7.49003 10.16 7.94003 10.16 8.49003C10.16 9.04003 9.69999 9.49003 9.14999 9.49003Z"
        fill="#959DB2"
      />
    </svg>
  );
}

export function AssetsBox() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M26.3008 8.9875L15.0008 15.525L3.70078 8.9875C4.20078 8.0625 4.92578 7.25 5.73828 6.8L12.4133 3.1C13.8383 2.3 16.1633 2.3 17.5883 3.1L24.2633 6.8C25.0758 7.25 25.8008 8.0625 26.3008 8.9875Z"
        fill="#1A355E"
      />
      <path
        opacity="0.6"
        d="M15.0008 15.525V27.5C14.0633 27.5 13.1258 27.3 12.4133 26.9L5.73828 23.2C4.22578 22.3625 2.98828 20.2625 2.98828 18.5375V11.4625C2.98828 10.6625 3.26328 9.78749 3.70078 8.98749L15.0008 15.525Z"
        fill="#1A355E"
      />
      <path
        d="M27.0133 11.4625V18.5375C27.0133 20.2625 25.7758 22.3625 24.2633 23.2L17.5883 26.9C16.8758 27.3 15.9383 27.5 15.0008 27.5V15.525L26.3008 8.98749C26.7383 9.78749 27.0133 10.6625 27.0133 11.4625Z"
        fill="#1A355E"
      />
      <path
        d="M22.8095 14.5353L21.1857 15.4728L21.1857 17.6563L19.2913 18.75L19.2913 20.625L21.1857 19.5313L21.1857 21.7147L22.8095 20.7772L22.8095 18.5938L24.7039 17.5L24.7039 15.625L22.8095 16.7188L22.8095 14.5353Z"
        fill="white"
      />
      <path
        d="M7.43572 14.5353L9.05952 15.4728L9.05952 17.6563L10.9539 18.75L10.9539 20.625L9.05952 19.5313L9.05952 21.7147L7.43572 20.7772L7.43572 18.5938L5.54129 17.5L5.54129 15.625L7.43572 16.7188L7.43572 14.5353Z"
        fill="white"
      />
    </svg>
  );
}

export function ClassA() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#8284E0" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M17.2737 9.19419L12.0004 12.245L6.72703 9.19419C6.96037 8.76252 7.2987 8.38335 7.67787 8.17335L10.7929 6.44669C11.4579 6.07335 12.5429 6.07335 13.2079 6.44669L16.3229 8.17335C16.702 8.38335 17.0404 8.76252 17.2737 9.19419Z"
        fill="#061327"
      />
      <path
        opacity="0.6"
        d="M12.0004 12.245V17.8333C11.5629 17.8333 11.1254 17.74 10.7929 17.5533L7.67786 15.8267C6.97203 15.4358 6.39453 14.4558 6.39453 13.6508V10.3492C6.39453 9.97582 6.52286 9.56749 6.72703 9.19415L12.0004 12.245Z"
        fill="#061327"
      />
      <path
        d="M17.6062 10.3492V13.6508C17.6062 14.4558 17.0287 15.4358 16.3229 15.8267L13.2079 17.5533C12.8754 17.74 12.4379 17.8333 12.0004 17.8333V12.245L17.2737 9.19415C17.4779 9.56749 17.6062 9.97582 17.6062 10.3492Z"
        fill="#061327"
      />
    </svg>
  );
}

export function ClassB() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#65AA8E" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M17.2737 9.19419L12.0004 12.245L6.72703 9.19419C6.96037 8.76252 7.2987 8.38335 7.67787 8.17335L10.7929 6.44669C11.4579 6.07335 12.5429 6.07335 13.2079 6.44669L16.3229 8.17335C16.702 8.38335 17.0404 8.76252 17.2737 9.19419Z"
        fill="#0E2041"
      />
      <path
        opacity="0.6"
        d="M12.0004 12.245V17.8333C11.5629 17.8333 11.1254 17.74 10.7929 17.5533L7.67786 15.8267C6.97203 15.4358 6.39453 14.4558 6.39453 13.6508V10.3492C6.39453 9.97582 6.52286 9.56749 6.72703 9.19415L12.0004 12.245Z"
        fill="#0E2041"
      />
      <path
        d="M17.6062 10.3492V13.6508C17.6062 14.4558 17.0287 15.4358 16.3229 15.8267L13.2079 17.5533C12.8754 17.74 12.4379 17.8333 12.0004 17.8333V12.245L17.2737 9.19415C17.4779 9.56749 17.6062 9.97582 17.6062 10.3492Z"
        fill="#0E2041"
      />
    </svg>
  );
}

export function ClassC() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#F0B78B" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M17.2737 9.19419L12.0004 12.245L6.72703 9.19419C6.96037 8.76252 7.2987 8.38335 7.67787 8.17335L10.7929 6.44669C11.4579 6.07335 12.5429 6.07335 13.2079 6.44669L16.3229 8.17335C16.702 8.38335 17.0404 8.76252 17.2737 9.19419Z"
        fill="#364E74"
      />
      <path
        opacity="0.6"
        d="M12.0004 12.245V17.8333C11.5629 17.8333 11.1254 17.74 10.7929 17.5533L7.67786 15.8267C6.97203 15.4358 6.39453 14.4558 6.39453 13.6508V10.3492C6.39453 9.97582 6.52286 9.56749 6.72703 9.19415L12.0004 12.245Z"
        fill="#364E74"
      />
      <path
        d="M17.6062 10.3492V13.6508C17.6062 14.4558 17.0287 15.4358 16.3229 15.8267L13.2079 17.5533C12.8754 17.74 12.4379 17.8333 12.0004 17.8333V12.245L17.2737 9.19415C17.4779 9.56749 17.6062 9.97582 17.6062 10.3492Z"
        fill="#364E74"
      />
    </svg>
  );
}

export function CardTotal() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="6" fill="#6C5DD3" />
      <path
        opacity="0.4"
        d="M11.0135 6.39669L8.00021 8.14002L4.98688 6.39669C5.12021 6.15002 5.31354 5.93335 5.53021 5.81335L7.31021 4.82669C7.69021 4.61335 8.31021 4.61335 8.69021 4.82669L10.4702 5.81335C10.6869 5.93335 10.8802 6.15002 11.0135 6.39669Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.6"
        d="M8.00021 8.14V11.3333C7.75021 11.3333 7.50021 11.28 7.31021 11.1733L5.53021 10.1867C5.12687 9.96333 4.79688 9.40333 4.79688 8.94333V7.05667C4.79688 6.84333 4.87021 6.61 4.98687 6.39667L8.00021 8.14Z"
        fill="#F2F2F2"
      />
      <path
        d="M11.2035 7.05667V8.94333C11.2035 9.40333 10.8735 9.96333 10.4702 10.1867L8.69021 11.1733C8.50021 11.28 8.25021 11.3333 8.00021 11.3333V8.14L11.0135 6.39667C11.1302 6.61 11.2035 6.84333 11.2035 7.05667Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function CardWork() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="6" fill="#1A8451" />
      <path
        opacity="0.4"
        d="M9.44676 4.66663H6.55676C5.42676 4.66663 4.66676 5.45996 4.66676 6.63996V9.36329C4.66676 10.54 5.42676 11.3333 6.55676 11.3333H9.44676C10.5768 11.3333 11.3334 10.54 11.3334 9.36329V6.63996C11.3334 5.45996 10.5768 4.66663 9.44676 4.66663Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.60447 9.08268C7.5298 9.08268 7.45514 9.05434 7.39814 8.99734L6.60714 8.20634C6.49314 8.09234 6.49314 7.90768 6.60714 7.79401C6.72114 7.68001 6.90547 7.67968 7.01947 7.79368L7.60447 8.37868L8.98047 7.00268C9.09447 6.88868 9.2788 6.88868 9.3928 7.00268C9.5068 7.11668 9.5068 7.30134 9.3928 7.41534L7.8108 8.99734C7.7538 9.05434 7.67914 9.08268 7.60447 9.08268Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function CardDown() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="6" fill="#EB5757" />
      <path
        d="M10.127 7.49653L7.08336 9.37174C7.01519 9.41352 6.92792 9.40952 6.8641 9.36018C6.57493 9.1375 6.31659 8.91171 6.14423 8.72193C6.14423 8.72193 5.99574 8.56992 5.93148 8.47347C5.82771 8.34191 5.77778 8.1699 5.77778 8.00278C5.77778 7.81521 5.83248 7.63787 5.94146 7.49609C5.96621 7.47075 6.06043 7.35919 6.14944 7.26808C6.66871 6.70094 8.02423 5.764 8.73715 5.47999C8.84092 5.43421 9.11793 5.33865 9.26164 5.33331C9.40014 5.33331 9.53387 5.36354 9.66239 5.42976C9.82043 5.52088 9.94417 5.66222 10.0136 5.82978C10.0584 5.94623 10.1274 6.29558 10.1274 6.30581C10.1721 6.55515 10.2055 6.90539 10.222 7.3143C10.2251 7.38764 10.1882 7.45875 10.127 7.49653Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.4"
        d="M9.92342 8.50654C10.0576 8.42343 10.2265 8.52966 10.22 8.68922C10.2039 9.06346 10.1761 9.39325 10.1422 9.6386C10.137 9.64393 10.068 10.0791 9.98855 10.2262C9.85004 10.4995 9.57824 10.6667 9.28604 10.6667H9.26173C9.07329 10.6618 8.67254 10.4946 8.67254 10.4844C8.47065 10.4004 8.2071 10.2582 7.92358 10.0871C7.79593 10.0097 7.7929 9.81994 7.92054 9.74127L9.92342 8.50654Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function CardRetired() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="6" fill="#B80F4B" />
      <g clipPath="url(#clip0_1653_17026)">
        <path
          opacity="0.4"
          d="M9.44663 4.66663H6.55663C5.42663 4.66663 4.66663 5.45996 4.66663 6.63996V9.36329C4.66663 10.54 5.42663 11.3333 6.55663 11.3333H9.44663C10.5766 11.3333 11.3333 10.54 11.3333 9.36329V6.63996C11.3333 5.45996 10.5766 4.66663 9.44663 4.66663Z"
          fill="white"
        />
        <path
          d="M9.00518 8.59011L8.41218 7.99744L9.00485 7.40477C9.11885 7.29111 9.11885 7.10611 9.00485 6.99244C8.89085 6.87777 8.70652 6.87811 8.59252 6.99211L7.99952 7.58477L7.40652 6.99144C7.29252 6.87744 7.10785 6.87811 6.99385 6.99144C6.88018 7.10544 6.88018 7.29044 6.99385 7.40411L7.58718 7.99744L6.99518 8.58911C6.88118 8.70311 6.88118 8.88811 6.99518 9.00144C7.05218 9.05877 7.12652 9.08711 7.20118 9.08711C7.27618 9.08711 7.35052 9.05877 7.40752 9.00177L7.99952 8.40977L8.59285 9.00277C8.64985 9.05977 8.72418 9.08811 8.79885 9.08811C8.87352 9.08811 8.94818 9.05944 9.00518 9.00277C9.11918 8.88877 9.11918 8.70411 9.00518 8.59011Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1653_17026">
          <rect width="8" height="8" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MedicalAssetsWorking() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="7" fill="#1C295D" />
      <path
        opacity="0.4"
        d="M10.6276 5.24988H7.37637C6.10512 5.24988 5.25012 6.14238 5.25012 7.46988V10.5336C5.25012 11.8574 6.10512 12.7499 7.37637 12.7499H10.6276C11.8989 12.7499 12.7501 11.8574 12.7501 10.5336V7.46988C12.7501 6.14238 11.8989 5.24988 10.6276 5.24988Z"
        fill="#F2F2F2"
      />
      <path
        d="M8.55504 10.2179C8.47104 10.2179 8.38704 10.1861 8.32292 10.1219L7.43304 9.23205C7.30479 9.1038 7.30479 8.89605 7.43304 8.76818C7.56129 8.63993 7.76867 8.63955 7.89692 8.7678L8.55504 9.42593L10.103 7.87793C10.2313 7.74968 10.4387 7.74968 10.5669 7.87793C10.6952 8.00618 10.6952 8.21393 10.5669 8.34218L8.78717 10.1219C8.72304 10.1861 8.63904 10.2179 8.55504 10.2179Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function AssetTick() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M13.5441 3.06252C14.4135 2.32502 15.8372 2.32502 16.7191 3.06252L18.7098 4.76252C19.0878 5.08752 19.7933 5.35002 20.2973 5.35002H22.4392C23.7747 5.35002 24.8708 6.43752 24.8708 7.76252V9.88752C24.8708 10.375 25.1354 11.0875 25.463 11.4625L27.1765 13.4375C27.9198 14.3 27.9198 15.7125 27.1765 16.5875L25.463 18.5625C25.1354 18.9375 24.8708 19.6375 24.8708 20.1375V22.2625C24.8708 23.5875 23.7747 24.675 22.4392 24.675H20.2973C19.8059 24.675 19.0878 24.9375 18.7098 25.2625L16.7191 26.9625C15.8498 27.7 14.4261 27.7 13.5441 26.9625L11.5535 25.2625C11.1755 24.9375 10.4699 24.675 9.96596 24.675H7.78629C6.45078 24.675 5.35465 23.5875 5.35465 22.2625V20.125C5.35465 19.6375 5.09006 18.9375 4.77508 18.5625L3.07419 16.575C2.34343 15.7125 2.34343 14.3125 3.07419 13.45L4.77508 11.4625C5.09006 11.0875 5.35465 10.3875 5.35465 9.90002V7.75002C5.35465 6.42502 6.45078 5.33752 7.78629 5.33752H9.96596C10.4573 5.33752 11.1755 5.07502 11.5535 4.75002L13.5441 3.06252Z"
        fill="#31CD82"
      />
      <path
        d="M13.5946 18.9625C13.3426 18.9625 13.1032 18.8625 12.9268 18.6875L9.87779 15.6625C9.51242 15.3 9.51242 14.7 9.87779 14.3375C10.2432 13.975 10.8479 13.975 11.2133 14.3375L13.5946 16.7L19.0122 11.325C19.3776 10.9625 19.9824 10.9625 20.3477 11.325C20.7131 11.6875 20.7131 12.2875 20.3477 12.65L14.2623 18.6875C14.0859 18.8625 13.8465 18.9625 13.5946 18.9625Z"
        fill="#31CD82"
      />
    </svg>
  );
}

export function AssetCross() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M13.4188 3.06252C14.2508 2.32502 15.6134 2.32502 16.4574 3.06252L18.3626 4.76252C18.7243 5.08752 19.3995 5.35002 19.8818 5.35002H21.9317C23.2098 5.35002 24.2589 6.43752 24.2589 7.76252V9.88752C24.2589 10.375 24.5121 11.0875 24.8256 11.4625L26.4654 13.4375C27.1769 14.3 27.1769 15.7125 26.4654 16.5875L24.8256 18.5625C24.5121 18.9375 24.2589 19.6375 24.2589 20.1375V22.2625C24.2589 23.5875 23.2098 24.675 21.9317 24.675H19.8818C19.4116 24.675 18.7243 24.9375 18.3626 25.2625L16.4574 26.9625C15.6254 27.7 14.2629 27.7 13.4188 26.9625L11.5137 25.2625C11.1519 24.9375 10.4767 24.675 9.99438 24.675H7.90837C6.63024 24.675 5.5812 23.5875 5.5812 22.2625V20.125C5.5812 19.6375 5.32798 18.9375 5.02654 18.5625L3.39872 16.575C2.69937 15.7125 2.69937 14.3125 3.39872 13.45L5.02654 11.4625C5.32798 11.0875 5.5812 10.3875 5.5812 9.90002V7.75002C5.5812 6.42502 6.63024 5.33752 7.90837 5.33752H9.99438C10.4646 5.33752 11.1519 5.07502 11.5137 4.75002L13.4188 3.06252Z"
        fill="#EB5757"
      />
      <path
        d="M17.8199 12L12.0322 18"
        stroke="#EB5757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8199 18L12.0322 12"
        stroke="#EB5757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DueSVG() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="7" fill="#F2994A" />
      <path
        d="M10.8928 8.93362L7.46878 11.0432C7.39209 11.0902 7.29391 11.0857 7.22211 11.0302C6.8968 10.7797 6.60617 10.5257 6.41225 10.3122C6.41225 10.3122 6.2452 10.1412 6.17291 10.0327C6.05617 9.88467 6 9.69116 6 9.50315C6 9.29214 6.06155 9.09263 6.18415 8.93312C6.21199 8.90462 6.31798 8.77911 6.41812 8.67661C7.00231 8.03858 8.52726 6.98452 9.3293 6.66501C9.44604 6.61351 9.75767 6.506 9.91935 6.5C10.0752 6.5 10.2256 6.534 10.3702 6.60851C10.548 6.71101 10.6872 6.87002 10.7653 7.05853C10.8157 7.18953 10.8933 7.58255 10.8933 7.59405C10.9436 7.87457 10.9812 8.26859 10.9998 8.72861C11.0032 8.81112 10.9617 8.89112 10.8928 8.93362Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.4"
        d="M10.6638 10.0699C10.8148 9.97636 11.0048 10.0959 10.9975 10.2754C10.9794 10.6964 10.9481 11.0674 10.91 11.3434C10.9042 11.3494 10.8265 11.839 10.7371 12.0045C10.5813 12.312 10.2755 12.5 9.9468 12.5H9.91944C9.70746 12.4945 9.25661 12.3065 9.25661 12.295C9.02948 12.2005 8.73299 12.0405 8.41403 11.848C8.27043 11.7609 8.26701 11.5474 8.41061 11.4589L10.6638 10.0699Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function MaintenanceA() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#8284E0" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#DA615C"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#DA615C"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#DA615C"
      />
    </svg>
  );
}

export function MaintenanceB() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#65AA8E" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0005 15.3063L8.40879 11.4927C8.70046 10.9532 9.12337 10.4792 9.59733 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#C2413A"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#C2413A"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#C2413A"
      />
    </svg>
  );
}

export function MaintenanceC() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F0B78B" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0005 15.3063L8.40879 11.4927C8.70046 10.9532 9.12337 10.4792 9.59733 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#EF8985"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#EF8985"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#EF8985"
      />
    </svg>
  );
}

export function DueA() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#8284E0" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#E59C59"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#E59C59"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#E59C59"
      />
    </svg>
  );
}

export function DueB() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#65AA8E" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#D57F38"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#D57F38"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#D57F38"
      />
    </svg>
  );
}

export function DueC() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F0B78B" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#F4B57B"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#F4B57B"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#F4B57B"
      />
    </svg>
  );
}

export function NonMedicalAssetsSVG() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M26.3008 8.9875L15.0008 15.525L3.70078 8.9875C4.20078 8.0625 4.92578 7.25 5.73828 6.8L12.4133 3.1C13.8383 2.3 16.1633 2.3 17.5883 3.1L24.2633 6.8C25.0758 7.25 25.8008 8.0625 26.3008 8.9875Z"
        fill="#1A355E"
      />
      <path
        opacity="0.6"
        d="M15.0008 15.525V27.5C14.0633 27.5 13.1258 27.3 12.4133 26.9L5.73828 23.2C4.22578 22.3625 2.98828 20.2625 2.98828 18.5375V11.4625C2.98828 10.6625 3.26328 9.78755 3.70078 8.98755L15.0008 15.525Z"
        fill="#1A355E"
      />
      <path
        d="M27.0133 11.4625V18.5375C27.0133 20.2625 25.7758 22.3625 24.2633 23.2L17.5883 26.9C16.8758 27.3 15.9383 27.5 15.0008 27.5V15.525L26.3008 8.98755C26.7383 9.78755 27.0133 10.6625 27.0133 11.4625Z"
        fill="#1A355E"
      />
    </svg>
  );
}

export function GenericAssetsSVG() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M26.3008 8.9875L15.0008 15.525L3.70078 8.9875C4.20078 8.0625 4.92578 7.25 5.73828 6.8L12.4133 3.1C13.8383 2.3 16.1633 2.3 17.5883 3.1L24.2633 6.8C25.0758 7.25 25.8008 8.0625 26.3008 8.9875Z"
        fill="#959DB2"
      />
      <path
        opacity="0.6"
        d="M15.0008 15.525V27.5C14.0633 27.5 13.1258 27.3 12.4133 26.9L5.73828 23.2C4.22578 22.3625 2.98828 20.2625 2.98828 18.5375V11.4625C2.98828 10.6625 3.26328 9.78755 3.70078 8.98755L15.0008 15.525Z"
        fill="#959DB2"
      />
      <path
        d="M27.0133 11.4625V18.5375C27.0133 20.2625 25.7758 22.3625 24.2633 23.2L17.5883 26.9C16.8758 27.3 15.9383 27.5 15.0008 27.5V15.525L26.3008 8.98755C26.7383 9.78755 27.0133 10.6625 27.0133 11.4625Z"
        fill="#959DB2"
      />
    </svg>
  );
}

export function WorkingA() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#8284E0" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0005 15.3063L8.40881 11.4927C8.70048 10.9532 9.1234 10.4792 9.59736 10.2167L13.4911 8.05837C14.3224 7.59171 15.6786 7.59171 16.5099 8.05837L20.4036 10.2167C20.8776 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#061327"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#061327"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#061327"
      />
    </svg>
  );
}

export function WorkingB() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#65AA8E" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#0E2041"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#0E2041"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#0E2041"
      />
    </svg>
  );
}

export function WorkingC() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F0B78B" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#364E74"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#364E74"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#364E74"
      />
    </svg>
  );
}

export function DMA() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#8284E0" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0004 15.3063L8.40878 11.4927C8.70045 10.9532 9.12337 10.4792 9.59732 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#DA615C"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#DA615C"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#DA615C"
      />
    </svg>
  );
}

export function DMB() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#65AA8E" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0005 15.3063L8.40879 11.4927C8.70046 10.9532 9.12337 10.4792 9.59733 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#C2413A"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#C2413A"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#C2413A"
      />
    </svg>
  );
}

export function DMC() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F0B78B" fillOpacity="0.15" />
      <path
        opacity="0.4"
        d="M21.5921 11.4927L15.0005 15.3063L8.40879 11.4927C8.70046 10.9532 9.12337 10.4792 9.59733 10.2167L13.4911 8.05837C14.3223 7.59171 15.6786 7.59171 16.5098 8.05837L20.4036 10.2167C20.8775 10.4792 21.3005 10.9532 21.5921 11.4927Z"
        fill="#EF8985"
      />
      <path
        opacity="0.6"
        d="M15.0005 15.3062V22.2916C14.4536 22.2916 13.9067 22.175 13.4911 21.9416L9.59733 19.7833C8.71504 19.2948 7.99316 18.0698 7.99316 17.0635V12.9364C7.99316 12.4698 8.15358 11.9593 8.40879 11.4927L15.0005 15.3062Z"
        fill="#EF8985"
      />
      <path
        d="M22.0077 12.9364V17.0635C22.0077 18.0698 21.2859 19.2948 20.4036 19.7833L16.5098 21.9416C16.0942 22.175 15.5473 22.2916 15.0005 22.2916V15.3062L21.5921 11.4927C21.8473 11.9593 22.0077 12.4698 22.0077 12.9364Z"
        fill="#EF8985"
      />
    </svg>
  );
}

export function NonMedicalAssetCard() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M26.3008 8.9875L15.0008 15.525L3.70078 8.9875C4.20078 8.0625 4.92578 7.25 5.73828 6.8L12.4133 3.1C13.8383 2.3 16.1633 2.3 17.5883 3.1L24.2633 6.8C25.0758 7.25 25.8008 8.0625 26.3008 8.9875Z"
        fill="#1A355E"
      />
      <path
        opacity="0.6"
        d="M15.0008 15.525V27.5C14.0633 27.5 13.1258 27.3 12.4133 26.9L5.73828 23.2C4.22578 22.3625 2.98828 20.2625 2.98828 18.5375V11.4625C2.98828 10.6625 3.26328 9.78749 3.70078 8.98749L15.0008 15.525Z"
        fill="#1A355E"
      />
      <path
        d="M27.0133 11.4625V18.5375C27.0133 20.2625 25.7758 22.3625 24.2633 23.2L17.5883 26.9C16.8758 27.3 15.9383 27.5 15.0008 27.5V15.525L26.3008 8.98749C26.7383 9.78749 27.0133 10.6625 27.0133 11.4625Z"
        fill="#1A355E"
      />
    </svg>
  );
}

export function Filter() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15H15.75C15.5511 15 15.3603 15.079 15.2197 15.2197C15.079 15.3603 15 15.5511 15 15.75C15 15.9489 15.079 16.1397 15.2197 16.2803C15.3603 16.421 15.5511 16.5 15.75 16.5H20.25C20.4489 16.5 20.6397 16.421 20.7803 16.2803C20.921 16.1397 21 15.9489 21 15.75ZM21 11.25C21 11.0511 20.921 10.8603 20.7803 10.7197C20.6397 10.579 20.4489 10.5 20.25 10.5H9.75C9.55109 10.5 9.36032 10.579 9.21967 10.7197C9.07902 10.8603 9 11.0511 9 11.25C9 11.4489 9.07902 11.6397 9.21967 11.7803C9.36032 11.921 9.55109 12 9.75 12H20.25C20.4489 12 20.6397 11.921 20.7803 11.7803C20.921 11.6397 21 11.4489 21 11.25ZM21 6.75C21 6.55109 20.921 6.36032 20.7803 6.21967C20.6397 6.07902 20.4489 6 20.25 6H3.75C3.55109 6 3.36032 6.07902 3.21967 6.21967C3.07902 6.36032 3 6.55109 3 6.75C3 6.94891 3.07902 7.13968 3.21967 7.28033C3.36032 7.42098 3.55109 7.5 3.75 7.5H20.25C20.4489 7.5 20.6397 7.42098 20.7803 7.28033C20.921 7.13968 21 6.94891 21 6.75Z"
        fill="#1C295D"
      />
    </svg>
  );
}

export function DashboardFilter() {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6.5L21 6.5"
        stroke="#1A355E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.3667L19 11.3667"
        stroke="#1A355E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16.5L17 16.5"
        stroke="#1A355E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RefreshIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11C21 16.52 16.52 21 11 21C5.48 21 2.11 15.44 2.11 15.44M2.11 15.44H6.63M2.11 15.44V20.44M1 11C1 5.48 5.44 1 11 1C17.67 1 21 6.56 21 6.56M21 6.56V1.56M21 6.56H16.56"
        stroke="#1A355E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CMRespond() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="#F1963A" />
    </svg>
  );
}

export function CMRepair() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="#A166AB" />
    </svg>
  );
}

export function CMApprove() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="#0AB39C" />
    </svg>
  );
}

export function CMClose() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="black" />
    </svg>
  );
}

export function Download() {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.001 13.5411C9.58701 13.5411 9.25101 13.2051 9.25101 12.7911V0.750122C9.25101 0.336122 9.58701 0.00012207 10.001 0.00012207C10.415 0.00012207 10.751 0.336122 10.751 0.750122V12.7911C10.751 13.2051 10.415 13.5411 10.001 13.5411Z"
        fill="#1A355E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.001 13.5412C9.80201 13.5412 9.61001 13.4622 9.47001 13.3202L6.55401 10.3932C6.26201 10.0992 6.26301 9.62415 6.55601 9.33215C6.85001 9.04015 7.32401 9.04015 7.61601 9.33415L10.001 11.7292L12.386 9.33415C12.678 9.04015 13.152 9.04015 13.446 9.33215C13.739 9.62415 13.74 10.0992 13.448 10.3932L10.532 13.3202C10.392 13.4622 10.2 13.5412 10.001 13.5412Z"
        fill="#1A355E"
      />
      <mask
        id="mask0_2158_10447"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.000213623 4.73267H20V18.4767H0.000213623V4.73267Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2158_10447)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5752 18.4767H4.43521C1.99021 18.4767 0.000213623 16.4877 0.000213623 14.0417V9.15667C0.000213623 6.71667 1.98521 4.73267 4.42621 4.73267H5.36721C5.78121 4.73267 6.11721 5.06867 6.11721 5.48267C6.11721 5.89667 5.78121 6.23267 5.36721 6.23267H4.42621C2.81221 6.23267 1.50021 7.54367 1.50021 9.15667V14.0417C1.50021 15.6607 2.81621 16.9767 4.43521 16.9767H15.5752C17.1872 16.9767 18.5002 15.6637 18.5002 14.0517V9.16767C18.5002 7.54867 17.1832 6.23267 15.5662 6.23267H14.6342C14.2202 6.23267 13.8842 5.89667 13.8842 5.48267C13.8842 5.06867 14.2202 4.73267 14.6342 4.73267H15.5662C18.0112 4.73267 20.0002 6.72267 20.0002 9.16767V14.0517C20.0002 16.4917 18.0142 18.4767 15.5752 18.4767Z"
          fill="#1A355E"
        />
      </g>
    </svg>
  );
}

// New Dashboard Icons

export function TotalAssets() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="24" fill="#5BB647" />
      <path
        opacity="0.4"
        d="M21.1503 23.4938L15.5003 26.7625L9.85034 23.4938C10.1003 23.0313 10.4628 22.625 10.8691 22.4L14.2066 20.55C14.9191 20.15 16.0816 20.15 16.7941 20.55L20.1316 22.4C20.5378 22.625 20.9003 23.0313 21.1503 23.4938Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.6"
        d="M15.5004 26.7625V32.75C15.0316 32.75 14.5629 32.65 14.2066 32.45L10.8691 30.6C10.1129 30.1813 9.49414 29.1313 9.49414 28.2688V24.7313C9.49414 24.3313 9.63164 23.8938 9.85039 23.4938L15.5004 26.7625Z"
        fill="#F2F2F2"
      />
      <path
        d="M21.5066 24.7313V28.2688C21.5066 29.1313 20.8879 30.1813 20.1316 30.6L16.7941 32.45C16.4379 32.65 15.9691 32.75 15.5004 32.75V26.7625L21.1504 23.4938C21.3691 23.8938 21.5066 24.3313 21.5066 24.7313Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.4"
        d="M38.0406 17.19L29.0006 22.42L19.9606 17.19C20.3606 16.45 20.9406 15.8 21.5906 15.44L26.9306 12.48C28.0706 11.84 29.9306 11.84 31.0706 12.48L36.4106 15.44C37.0606 15.8 37.6406 16.45 38.0406 17.19Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.6"
        d="M29.0006 22.42V32C28.2506 32 27.5006 31.84 26.9306 31.52L21.5906 28.56C20.3806 27.89 19.3906 26.21 19.3906 24.83V19.17C19.3906 18.53 19.6106 17.83 19.9606 17.19L29.0006 22.42Z"
        fill="#F2F2F2"
      />
      <path
        d="M38.6106 19.17V24.83C38.6106 26.21 37.6206 27.89 36.4106 28.56L31.0706 31.52C30.5006 31.84 29.7506 32 29.0006 32V22.42L38.0406 17.19C38.3906 17.83 38.6106 18.53 38.6106 19.17Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function MedicalAssets() {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.841797" width="48" height="48" rx="24" fill="#4FC9FF" />
      <path opacity="0.4" d="M36.1426 17.9875L24.8426 24.525L13.5426 17.9875C14.0426 17.0625 14.7676 16.25 15.5801 15.8L22.2551 12.1C23.6801 11.3 26.0051 11.3 27.4301 12.1L34.1051 15.8C34.9176 16.25 35.6426 17.0625 36.1426 17.9875Z" fill="#F2F2F2" />
      <path opacity="0.6" d="M24.8426 24.5248V36.4998C23.9051 36.4998 22.9676 36.2998 22.2551 35.8998L15.5801 32.1998C14.0676 31.3623 12.8301 29.2623 12.8301 27.5373V20.4623C12.8301 19.6623 13.1051 18.7873 13.5426 17.9873L24.8426 24.5248Z" fill="#F2F2F2" />
      <path d="M36.8551 20.4623V27.5373C36.8551 29.2623 35.6176 31.3623 34.1051 32.1998L27.4301 35.8998C26.7176 36.2998 25.7801 36.4998 24.8426 36.4998V24.5248L36.1426 17.9873C36.5801 18.7873 36.8551 19.6623 36.8551 20.4623Z" fill="#F2F2F2" />
      <path d="M32.6513 23.5352L31.0275 24.4727L31.0275 26.6561L29.1331 27.7498L29.1331 29.6248L31.0275 28.5311L31.0275 30.7145L32.6513 29.777L32.6513 27.5936L34.5457 26.4998L34.5457 24.6248L32.6513 25.7186L32.6513 23.5352Z" fill="#FF5454" />
      <path d="M17.2775 23.5352L18.9013 24.4727L18.9013 26.6561L20.7957 27.7498L20.7957 29.6248L18.9013 28.5311L18.9013 30.7145L17.2775 29.777L17.2775 27.5936L15.3831 26.4998L15.3831 24.6248L17.2775 25.7186L17.2775 23.5352Z" fill="#FF5454" />
    </svg>
  );
}

export function NonMedicalAssets() {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.841797" width="48" height="48" rx="24" fill="#876AFE" />
      <path opacity="0.4" d="M36.1426 17.9875L24.8426 24.525L13.5426 17.9875C14.0426 17.0625 14.7676 16.25 15.5801 15.8L22.2551 12.1C23.6801 11.3 26.0051 11.3 27.4301 12.1L34.1051 15.8C34.9176 16.25 35.6426 17.0625 36.1426 17.9875Z" fill="#F2F2F2" />
      <path opacity="0.6" d="M24.8426 24.5248V36.4998C23.9051 36.4998 22.9676 36.2998 22.2551 35.8998L15.5801 32.1998C14.0676 31.3623 12.8301 29.2623 12.8301 27.5373V20.4623C12.8301 19.6623 13.1051 18.7873 13.5426 17.9873L24.8426 24.5248Z" fill="#F2F2F2" />
      <path d="M36.8551 20.4623V27.5373C36.8551 29.2623 35.6176 31.3623 34.1051 32.1998L27.4301 35.8998C26.7176 36.2998 25.7801 36.4998 24.8426 36.4998V24.5248L36.1426 17.9873C36.5801 18.7873 36.8551 19.6623 36.8551 20.4623Z" fill="#F2F2F2" />
    </svg>
  );
}

export function NewMedicalAssets({ fill = "#2A347B" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.0406 5.19L10.0006 10.42L0.960571 5.19C1.36057 4.45 1.94057 3.8 2.59057 3.44L7.93057 0.48C9.07057 -0.16 10.9306 -0.16 12.0706 0.48L17.4106 3.44C18.0606 3.8 18.6406 4.45 19.0406 5.19Z"
        fill={fill}
      />
      <path
        opacity="0.6"
        d="M10.0006 10.42V20C9.25062 20 8.50062 19.84 7.93062 19.52L2.59062 16.56C1.38062 15.89 0.390625 14.21 0.390625 12.83V7.17C0.390625 6.53 0.610625 5.83 0.960625 5.19L10.0006 10.42Z"
        fill={fill}
      />
      <path
        d="M19.6106 7.17V12.83C19.6106 14.21 18.6206 15.89 17.4106 16.56L12.0706 19.52C11.5006 19.84 10.7506 20 10.0006 20V10.42L19.0406 5.19C19.3906 5.83 19.6106 6.53 19.6106 7.17Z"
        fill={fill}
      />
      <path
        d="M16.2476 9.62823L14.9485 10.3782L14.9485 12.125L13.433 13L13.433 14.5L14.9485 13.625L14.9485 15.3717L16.2476 14.6217L16.2476 12.875L17.7631 12L17.7631 10.5L16.2476 11.375L16.2476 9.62823Z"
        fill="white"
      />
      <path
        d="M3.9486 9.62823L5.24764 10.3782L5.24764 12.125L6.76318 13L6.76318 14.5L5.24764 13.625L5.24764 15.3717L3.9486 14.6217L3.9486 12.875L2.43306 12L2.43306 10.5L3.9486 11.375L3.9486 9.62823Z"
        fill="white"
      />
    </svg>
  );
}

export function NewNonMedicalAssets({ fill = "#959DB2" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.0406 5.19L10.0006 10.42L0.960571 5.19C1.36057 4.45 1.94057 3.8 2.59057 3.44L7.93057 0.48C9.07057 -0.16 10.9306 -0.16 12.0706 0.48L17.4106 3.44C18.0606 3.8 18.6406 4.45 19.0406 5.19Z"
        fill={fill}
      />
      <path
        opacity="0.6"
        d="M10.0006 10.42V20C9.25062 20 8.50062 19.84 7.93062 19.52L2.59062 16.56C1.38062 15.89 0.390625 14.21 0.390625 12.83V7.17C0.390625 6.53 0.610625 5.83 0.960625 5.19L10.0006 10.42Z"
        fill={fill}
      />
      <path
        d="M19.6106 7.17V12.83C19.6106 14.21 18.6206 15.89 17.4106 16.56L12.0706 19.52C11.5006 19.84 10.7506 20 10.0006 20V10.42L19.0406 5.19C19.3906 5.83 19.6106 6.53 19.6106 7.17Z"
        fill={fill}
      />
    </svg>
  );
}

export function NonMedicalIcon() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.600098" width="48" height="48" rx="24" fill="#2A347B" />
      <path
        opacity="0.4"
        d="M35.9009 17.9875L24.6009 24.525L13.3009 17.9875C13.8009 17.0625 14.5259 16.25 15.3384 15.8L22.0134 12.1C23.4384 11.3 25.7634 11.3 27.1884 12.1L33.8634 15.8C34.6759 16.25 35.4009 17.0625 35.9009 17.9875Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.6"
        d="M24.6009 24.525V36.5C23.6634 36.5 22.7259 36.3001 22.0134 35.9001L15.3384 32.2C13.8259 31.3625 12.5884 29.2625 12.5884 27.5375V20.4625C12.5884 19.6625 12.8634 18.7875 13.3009 17.9875L24.6009 24.525Z"
        fill="#F2F2F2"
      />
      <path
        d="M36.6134 20.4625V27.5375C36.6134 29.2625 35.3759 31.3625 33.8634 32.2L27.1884 35.9001C26.4759 36.3001 25.5384 36.5 24.6009 36.5V24.525L35.9009 17.9875C36.3384 18.7875 36.6134 19.6625 36.6134 20.4625Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export function MedicalIcon() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.841797" width="48" height="48" rx="24" fill="#5BB647" />
      <path
        opacity="0.4"
        d="M36.1426 17.9875L24.8426 24.525L13.5426 17.9875C14.0426 17.0625 14.7676 16.25 15.5801 15.8L22.2551 12.1C23.6801 11.3 26.0051 11.3 27.4301 12.1L34.1051 15.8C34.9176 16.25 35.6426 17.0625 36.1426 17.9875Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.6"
        d="M24.8426 24.525V36.5C23.9051 36.5 22.9676 36.3001 22.2551 35.9001L15.5801 32.2C14.0676 31.3625 12.8301 29.2625 12.8301 27.5375V20.4625C12.8301 19.6625 13.1051 18.7875 13.5426 17.9875L24.8426 24.525Z"
        fill="#F2F2F2"
      />
      <path
        d="M36.8551 20.4625V27.5375C36.8551 29.2625 35.6176 31.3625 34.1051 32.2L27.4301 35.9001C26.7176 36.3001 25.7801 36.5 24.8426 36.5V24.525L36.1426 17.9875C36.5801 18.7875 36.8551 19.6625 36.8551 20.4625Z"
        fill="#F2F2F2"
      />
      <path
        d="M32.6513 23.5353L31.0275 24.4728L31.0275 26.6562L29.1331 27.75L29.1331 29.625L31.0275 28.5312L31.0275 30.7147L32.6513 29.7772L32.6513 27.5937L34.5457 26.5L34.5457 24.625L32.6513 25.7187L32.6513 23.5353Z"
        fill="#FF5454"
      />
      <path
        d="M17.2775 23.5353L18.9013 24.4728L18.9013 26.6562L20.7957 27.75L20.7957 29.625L18.9013 28.5312L18.9013 30.7147L17.2775 29.7772L17.2775 27.5937L15.3831 26.5L15.3831 24.625L17.2775 25.7187L17.2775 23.5353Z"
        fill="#FF5454"
      />
    </svg>
  );
}
